import {
  getListCredits,
  addCredits,
  editCredits,
  deleteCredits,
} from '@/services/creditsamount';

const getters = {
  listCredits: state => state.listCredits,
  per_page: state => state.per_page,
};

const actions = {
  async requestListCredits({ commit, rootGetters }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListCredits({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, filter);
      commit('SET_LIST', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestAddCredits({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await addCredits({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      dispatch('requestListCredits', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestEditCredits({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await editCredits({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      dispatch('requestListCredits', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDeleteCredit({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await deleteCredits({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, data);
      dispatch('requestListCredits', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
      throw err;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
};

const mutations = {
  SET_LIST(state, listCredits) {
    state.listCredits = listCredits;
  },
};

export default {
  namespaced: true,
  state: {
    listCredits: [],
    per_page: 50,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/CreditsAmount/index.js